module.exports = "<ng-container *ngIf=\"errorMessage()\">\r\n    {{ errorMessage() }}\r\n</ng-container>"